import React from 'react';
import useDictation from '../../hooks/useDictation';

/**
 * Input de texto con botón de dictado por voz.
 * CSS: reutiliza clases captura-desc-row, captura-mic-btn de captura-foto.css
 *
 * @param {Object} props
 * @param {string} props.value - Valor actual
 * @param {Function} props.onChange - Callback con nuevo valor (string)
 * @param {string} [props.placeholder] - Placeholder del input
 * @param {boolean} [props.disabled] - Deshabilitado
 * @param {boolean} [props.autoFocus] - Auto focus al montar
 * @returns {JSX.Element}
 */
function InputConDictado({ value, onChange, placeholder, disabled, autoFocus }) {
  const dictado = useDictation((text) => onChange(text));

  return (
    <div className="captura-desc-row">
      <input
        type="text"
        className="form-control"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter' && dictado.grabando) e.preventDefault(); }}
        placeholder={placeholder}
        disabled={disabled}
        autoFocus={autoFocus}
      />
      <button
        type="button"
        className={`captura-mic-btn${dictado.grabando ? ' captura-mic-btn--grabando' : ''}`}
        onClick={dictado.grabando ? dictado.detener : dictado.iniciar}
        disabled={disabled || dictado.procesando}
        title={dictado.grabando ? 'Detener grabación' : 'Dictar'}
        aria-label={dictado.grabando ? 'Detener grabación' : 'Activar dictado por voz'}
      >
        {dictado.procesando ? (
          <i className="fas fa-spinner fa-spin" />
        ) : dictado.grabando ? (
          <i className="fas fa-stop" />
        ) : (
          <i className="fas fa-microphone" />
        )}
      </button>
    </div>
  );
}

export default InputConDictado;
